export var AvatarIndicatorVariant;
(function (AvatarIndicatorVariant) {
    AvatarIndicatorVariant["status"] = "status";
    AvatarIndicatorVariant["custom"] = "custom";
})(AvatarIndicatorVariant || (AvatarIndicatorVariant = {}));
export var AvatarIndicatorStatus;
(function (AvatarIndicatorStatus) {
    AvatarIndicatorStatus["online"] = "online";
    AvatarIndicatorStatus["offline"] = "offline";
})(AvatarIndicatorStatus || (AvatarIndicatorStatus = {}));
//? Avatar Add Button
export var AvatarAddButtonSize;
(function (AvatarAddButtonSize) {
    AvatarAddButtonSize["xs"] = "xs";
    AvatarAddButtonSize["s"] = "s";
    AvatarAddButtonSize["m"] = "m";
})(AvatarAddButtonSize || (AvatarAddButtonSize = {}));
